import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data, options = {}, color = "#1976d2" }) => {
  const chartData = {
    labels: data.map((item) => item.value),
    datasets: [
      {
        label: "Count",
        data: data.map((item) => item.count),
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
      },
    ],
  };

  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const item = data[context.dataIndex];
            return `${item.count} responses (${item.percentage}%)`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
    ...options,
  };

  return (
    <div style={{ height: "300px" }}>
      <Bar
        data={chartData}
        options={defaultOptions}
      />
    </div>
  );
};

export default BarChart;
